import React from 'react';
import { FaMapMarkerAlt, FaBuilding, FaCheck, FaClock } from 'react-icons/fa';

interface Property {
  id: number;
  address: string;
  city: string;
  state: string;
  zipcode: string;
  latitude: number | null;
  longitude: number | null;
  fk_business_id: number;
}

interface PropertyCardProps {
  property: Property;
  isSelected: boolean;
  onToggle: () => void;
  showCheckbox?: boolean;
}

const PropertyCard: React.FC<PropertyCardProps> = ({ property, isSelected, onToggle, showCheckbox = true }) => {
  const hasCoordinates = property.latitude && property.longitude;
  
  return (
    <div className={`
      grid grid-cols-12 gap-4 items-center p-4 border-b border-gray-100 transition-all duration-200 hover:bg-gray-50 cursor-pointer
      ${isSelected 
        ? 'bg-blue-50 border-l-4 border-l-blue-500 shadow-sm' 
        : 'bg-white hover:border-l-2 hover:border-l-gray-200'
      }
    `}
    onClick={() => showCheckbox && onToggle()}
    >
      {/* Selection Checkbox */}
      {showCheckbox ? (
        <div className="col-span-1 flex justify-center">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={(e) => {
              e.stopPropagation();
              onToggle();
            }}
            className="h-5 w-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500 focus:ring-2 cursor-pointer"
          />
        </div>
      ) : (
        <div className="col-span-1"></div>
      )}
      
      {/* Property Address */}
      <div className="col-span-5 min-w-0">
        <div className="flex items-center gap-2">
          <FaMapMarkerAlt size={14} className={`${isSelected ? 'text-blue-500' : 'text-gray-400'}`} />
          <h3 className={`font-medium truncate ${isSelected ? 'text-blue-900' : 'text-gray-900'}`}>
            {property.address}
          </h3>
        </div>
      </div>
      
      {/* Location */}
      <div className={`col-span-2 text-sm ${isSelected ? 'text-blue-700' : 'text-gray-600'}`}>
        {property.city}, {property.state} {property.zipcode}
      </div>
      
      {/* Property ID */}
      <div className={`col-span-2 text-sm font-mono ${isSelected ? 'text-blue-700' : 'text-gray-500'}`}>
        {property.id}
      </div>
      
      {/* Status Badge */}
      <div className="col-span-2">
        {hasCoordinates ? (
          <div className="flex items-center gap-2 px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm font-medium">
            <FaCheck size={12} />
            <span>Geocoded</span>
          </div>
        ) : (
          <div className="flex items-center gap-2 px-3 py-1 bg-yellow-100 text-yellow-800 rounded-full text-sm font-medium">
            <FaClock size={12} />
            <span>Missing</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default PropertyCard;
